import { render, staticRenderFns } from "./ClientVisit.vue?vue&type=template&id=20caf9dd"
import script from "./ClientVisit.vue?vue&type=script&lang=js"
export * from "./ClientVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports